<template>
  <CCard class="shadow-sm border-0 mb-4">
    <CCardHeader class="bg-white border-bottom-0 pt-3 px-3">
      <h5 class="font-weight-bold mb-0">
        Traffic "Waste"
      </h5>
    </CCardHeader>
    <CCardBody class="px-3 pb-3">
      <div v-if="!isLoading && chartData && chartData.labels.length > 0">
        <CChartBar
          :datasets="chartData.datasets"
          :labels="chartData.labels"
          :options="chartData.options"
          style="height: 300px;"
        />
      </div>
      <div v-else class="text-center py-5">
        <CSpinner color="primary" grow v-if="isLoading"/>
        <p v-else class="text-muted">No data available</p>
      </div>
    </CCardBody>
  </CCard>
</template>

<script>
import { mapGetters } from 'vuex'
import { CChartBar } from '@coreui/vue-chartjs'
import moment from 'moment'

export default {
  name: 'TrafficQualityChart',
  components: {
    CChartBar
  },
  computed: {
    ...mapGetters('insights', {
      apiDataPoints: 'revenueChartData',
      isLoading: 'isRevenueChartLoading'
    }),
    chartData() {
      const trafficPoints = this.apiDataPoints || []
      const trafficValid = trafficPoints.filter(p => p.date || p.period)
      const sortedTraffic = [...trafficValid].sort((a, b) => new Date(a.date || a.period) - new Date(b.date || b.period))
      
      const labels = sortedTraffic.map(p => moment(p.date || p.period).format('MMM YYYY'))
      const blocked = sortedTraffic.map(p => p.blockedCalls || 0)
      const duplicate = sortedTraffic.map(p => p.duplicateCalls || 0)
      const converted = sortedTraffic.map(p => p.convertedCalls || 0)
      const nonConnected = sortedTraffic.map(p => {
        const total = p.callCount || 0
        const known = (p.blockedCalls || 0) + (p.duplicateCalls || 0) + (p.convertedCalls || 0)
        const remainder = total - known
        return remainder > 0 ? remainder : 0
      })

      const datasets = [
        {
          label: 'Blocked',
          backgroundColor: '#e55353', // Red
          data: blocked,
          barPercentage: 0.6,
          categoryPercentage: 0.8
        },
        {
          label: 'Duplicate',
          backgroundColor: '#f9b115', // Yellow/Orange
          data: duplicate,
          barPercentage: 0.6,
          categoryPercentage: 0.8
        },
        {
          label: 'Non-Connected',
          backgroundColor: '#ced2d8', // Gray
          data: nonConnected,
          barPercentage: 0.6,
          categoryPercentage: 0.8
        },
        {
          label: 'Converted',
          backgroundColor: '#2eb85c', // Green
          data: converted,
          barPercentage: 0.6,
          categoryPercentage: 0.8
        }
      ]

      return {
        labels,
        datasets,
        options: {
          maintainAspectRatio: false,
          legend: { display: true, position: 'top' },
          tooltips: {
            mode: 'index',
            intersect: false,
            callbacks: {
              label: (tooltipItem, data) => {
                const dataset = data.datasets[tooltipItem.datasetIndex]
                const val = dataset.data[tooltipItem.index]
                const label = dataset.label 
                let total = 0
                data.datasets.forEach(ds => { total += ds.data[tooltipItem.index] })
                const pct = total > 0 ? ((val / total) * 100).toFixed(1) : '0.0'
                return `${label}: ${Number(val).toLocaleString()} (${pct}%)`
              }
            }
          },
          scales: {
            xAxes: [{ stacked: true, gridLines: { display: false } }],
            yAxes: [{ 
              stacked: true, 
              ticks: { 
                beginAtZero: true,
                callback: (value) => value
              }
            }]
          }
        }
      }
    }
  }
}
</script>
